var React = require('react');

function ChangelogBigLoading (props) {
    return React.createElement("svg",props,React.createElement("rect",{"width":"100","height":"16","rx":"8","fill":"white","fillOpacity":"0.1"}));
}

ChangelogBigLoading.defaultProps = {"width":"100","height":"16","viewBox":"0 0 100 16","fill":"none"};

module.exports = ChangelogBigLoading;

ChangelogBigLoading.default = ChangelogBigLoading;
